exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pay-content[data-v-59c71a7d] {\n  padding: 0.4rem 0.666667rem;\n  text-align: center;\n}\n.pay-content .pay-info[data-v-59c71a7d] {\n  font-size: 0.373333rem;\n}\n.pay-content .pay-btn[data-v-59c71a7d] {\n  width: 100%;\n  margin-top: 1.333333rem;\n}", ""]);

// exports
